import { Link } from 'react-router-dom'
import { Plus } from 'lucide-react'
import { useBranches } from '@/modules/branches/hooks/useBranches'
import { useBranchMutation } from '@/modules/branches/hooks/useBranchMutation'
import { BranchesTable } from '@/modules/branches/components/BranchesTable'
import { ErrorState } from '@/shared/components/ui/atoms/ErrorState'

export function BranchesListPage() {
  const { data, isLoading, error, refetch } = useBranches()
  const { remove } = useBranchMutation()

  const handleDelete = async (id: number) => {
    await remove(id)
    refetch()
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Sucursales</h1>
        <Link to="/branches/new" className="btn btn-primary flex items-center gap-1.5">
          <Plus size={16} />
          Nueva Sucursal
        </Link>
      </div>

      {error && <ErrorState message={error} onRetry={refetch} />}

      <div className="card">
        <BranchesTable
          data={data}
          onDelete={handleDelete}
          isLoading={isLoading}
        />
      </div>
    </div>
  )
}
